/**
 * Converte erros de SDKs (Mercado Pago Brick, axios, etc.) em texto legível.
 */
export function formatUnknownError(error: unknown, fallback = 'Erro inesperado.'): string {
  if (error == null) return fallback;
  if (typeof error === 'string') {
    const trimmed = error.trim();
    return trimmed || fallback;
  }
  if (error instanceof Error) {
    const axiosData = (error as Error & { response?: { data?: { message?: unknown } } }).response?.data;
    if (typeof axiosData?.message === 'string' && axiosData.message.trim()) {
      return axiosData.message.trim();
    }
    const msg = error.message?.trim();
    return msg || fallback;
  }
  if (typeof error === 'object') {
    const o = error as Record<string, unknown>;
    if (typeof o.message === 'string' && o.message.trim()) return o.message.trim();
    if (typeof o.error === 'string' && o.error.trim()) return o.error.trim();
    if (typeof o.description === 'string' && o.description.trim()) return o.description.trim();
    if (Array.isArray(o.cause)) {
      const parts = o.cause.map((c) => formatUnknownError(c, '')).filter(Boolean);
      if (parts.length) return parts.join('; ');
    }
    if (o.cause) return formatUnknownError(o.cause, fallback);
    const response = o.response as Record<string, unknown> | undefined;
    const data = response?.data as Record<string, unknown> | undefined;
    if (typeof data?.message === 'string' && data.message.trim()) return data.message.trim();
  }
  try {
    const json = JSON.stringify(error);
    if (json && json !== '{}') return json;
  } catch {
    /* ignore */
  }
  return fallback;
}
